import React from 'react';

import { QuestionInfo } from 'components/assessment/common/QuestionInfo';
import { InputField } from 'components/ui/form-fields';

type GestationalAgeStepProps = {
  weeksValue: number | null;
  daysValue: number | null;
  onChangeWeeks: (value: number | null) => void;
  onChangeDays: (value: number | null) => void;
};

export const GestationalAgeStep: React.FC<GestationalAgeStepProps> = ({
  weeksValue,
  daysValue,
  onChangeWeeks,
  onChangeDays,
}) => {
  const handleWeeksChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val === '') {
      onChangeWeeks(null);
    } else {
      const numValue = parseInt(val, 10);
      if (!isNaN(numValue) && numValue >= 0) {
        onChangeWeeks(numValue);
      }
    }
  };

  const handleDaysChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val === '') {
      onChangeDays(null);
    } else {
      const numValue = parseInt(val, 10);
      if (!isNaN(numValue) && numValue >= 0 && numValue <= 6) {
        onChangeDays(numValue);
      }
    }
  };

  return (
    <div>
      <QuestionInfo title="What is the patient’s gestational age?" />

      <div className="flex gap-4">
        <div className="flex-1">
          <InputField
            label="Weeks"
            type="number"
            name="gestational-weeks"
            className="px-6 py-[18px] rounded-xl h-16"
            placeholder="0"
            min={0}
            value={weeksValue !== null ? weeksValue.toString() : '0'}
            onChange={handleWeeksChange}
          />
        </div>

        <div className="flex-1">
          <InputField
            label="Days"
            type="number"
            className="px-6 py-[18px] rounded-xl h-16"
            name="gestational-days"
            placeholder="0"
            min={0}
            max={6}
            value={daysValue !== null ? daysValue.toString() : '0'}
            onChange={handleDaysChange}
            errorMessage={
              daysValue !== undefined && daysValue !== null && (daysValue < 0 || daysValue > 6)
                ? 'Days must be between 0-6'
                : undefined
            }
          />
        </div>
      </div>
    </div>
  );
};
